
import { all, takeEvery, takeLatest } from "redux-saga/effects";
import { SAGA_ACTIONS } from "../resources/constants";
import * as BankTrans from './bankTrans';
import * as Budget from './budget';
import * as chartAccount from './chartAccount';
import * as CreditCard from './creditCard';
import * as FourThreeThree from './fourThreeThreeB';
import * as glBankFeed from './glBankFeed';
import * as glClassification from './glClassification';
import * as glViewRegister from './glViewRegister';
import * as QuickBook from './quickBook';
import * as ReportSaga from './report';
import * as Tax1099 from './tax1099';
import * as Settings from './settings';
import * as UserSaga from './user';

export default function* rootSaga() {
    yield all([
        // takeLatest(SAGA_ACTIONS.USER.LOGIN, UserSaga.login),
        takeLatest(SAGA_ACTIONS.USER.DETAILS, UserSaga.me),
        takeEvery(SAGA_ACTIONS.TRANSACTION.TRANS_LIST, BankTrans.bankTrans),
        takeLatest(SAGA_ACTIONS.TRANSACTION.CREATE_TRANSACTION_ADJUSTMENT, BankTrans.createAdjustment),
        takeLatest(SAGA_ACTIONS.TRANSACTION.DISCARD_TRANSACTION, BankTrans.discardTransaction),
        takeLatest(SAGA_ACTIONS.USER.USER_ACCESS, UserSaga.user_access),
        // takeLatest(SAGA_ACTIONS.USER.ACCOUNT_ALLOWANCE, UserSaga.user_allowance),
        // takeLatest(SAGA_ACTIONS.USER.USER_STEP_STATUS, UserSaga.user_step_status),
        // takeEvery(SAGA_ACTIONS.USER.USER_STEP_STATUS, UserSaga.user_step_status),

        takeEvery(SAGA_ACTIONS.CHART_ACCOUNT.LIST, chartAccount.list),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.DETAILS, chartAccount.accountDetails),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.CREATE, chartAccount.create),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.UPDATE, chartAccount.update),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.AVAILABLE_ACCOUNT, chartAccount.availableAccounts),
        takeEvery(SAGA_ACTIONS.CHART_ACCOUNT.GL_ACCOUNT_LIST, chartAccount.gl_account_list),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.LIST_TREE, chartAccount.list_tree),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.ACCOUNT_LEBEL, chartAccount.lebel),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.BANK_SALE_LIST, chartAccount.bankAccountList),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.BANK_SALE_UPDATE, chartAccount.bankAccountUpdate),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.FETCH_OPENNING_BALANCE, chartAccount.fetchOpenningAcc),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.POST_OPENNING_BALANCE, chartAccount.postOpenningAcc),

        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.GL_TRANS_LIST, glClassification.list),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.GL_RECONCILE_TRANS_LIST, glClassification.reconcileTxnList),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.GL_RECONCILE_OPENNING_BALANCE_FETCH, glClassification.reconcileOpenningBalanceFetch),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.GL_RECONCILE_TRANS_POST, glClassification.reconcilePost),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.GL_SALES_LIST, glClassification.saleList),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.BANK_GL_UPDATE, glClassification.bankGlUpdate),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.SALE_GL_UPDATE, glClassification.saleGlUpdate),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.REVENUE_GL_UPDATE, glClassification.revenueGlUpdate),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.CLASSIFICATION_STATUS, glClassification.classificationStatus),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.COMPLETE_STEP, glClassification.completeStatus),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.SKIP_BEGINNING_BALANCE, glClassification.skipBeginningBalance),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.GL_BANK_RECONCILE_BALANCES, glClassification.getBankReconcileBalances),
        takeLatest(SAGA_ACTIONS.GL_CLASSIFICATION.GL_RECONCILE_QBD_BACKFILL, glClassification.reconcileQbdBackfill),

        takeLatest(SAGA_ACTIONS.BANK_FEED.FETCH_LIST, glBankFeed.list),
        takeLatest(SAGA_ACTIONS.BANK_FEED.UPDATE, glBankFeed.feedUpdate),
        takeLatest(SAGA_ACTIONS.BANK_FEED.BULK_UPDATE, glBankFeed.feedBulkUpdate),
        takeLatest(SAGA_ACTIONS.BANK_FEED.FETCH_BANK_TEMPLATES, glBankFeed.fetchBankTemplates),
        takeLatest(SAGA_ACTIONS.BANK_FEED.ADD_BANK_ACCOUNT, glBankFeed.addBankAccount),
        takeLatest(SAGA_ACTIONS.BANK_FEED.ADD_BANK_TEMPLATE, glBankFeed.addBankTemplate),
        takeLatest(SAGA_ACTIONS.BANK_FEED.REQUEST_BANK, glBankFeed.requestBank),

        takeLatest(SAGA_ACTIONS.VIEW_REGISTER.FETCH_LIST, glViewRegister.list),
        takeLatest(SAGA_ACTIONS.VIEW_REGISTER.EXPORT_CSV, glViewRegister.exportTransactionsCsv),

        takeLatest(SAGA_ACTIONS.REPORT.BALANCE_SHEET, ReportSaga.balanceSheet),
        takeLatest(SAGA_ACTIONS.REPORT.REFRESH_BALANCE_SHEET, ReportSaga.balanceSheetRefresh),
        takeLatest(SAGA_ACTIONS.REPORT.REGENERATE_BALANCE_SHEET, ReportSaga.regenerateBalanceSheet),
        takeLatest(SAGA_ACTIONS.REPORT.BALANCE_SHEET_REFRESH_STATUS, ReportSaga.balanceSheetRefreshStatus),
        takeLatest(SAGA_ACTIONS.REPORT.REPORT_DOWNLOAD_BS, ReportSaga.reportDownload),
        takeLatest(SAGA_ACTIONS.REPORT.REPORT_DOWNLOAD_BT, ReportSaga.reportDownloadBT),
        takeLatest(SAGA_ACTIONS.REPORT.PROFIT_LOSSS, ReportSaga.profitLoss),
        takeLatest(SAGA_ACTIONS.REPORT.STATEMENT_OF_CASH_FLOW, ReportSaga.cashFlow),
        takeLatest(SAGA_ACTIONS.REPORT.DASHBOARD_RATIO, ReportSaga.dashboardRatio),
        takeLatest(SAGA_ACTIONS.REPORT.TXN_REGISTER_PL, ReportSaga.txnRegisterPL),

        takeLatest(SAGA_ACTIONS.FOUR_THREE_THREE_B.DETAILS, FourThreeThree.getData),
        takeLatest(SAGA_ACTIONS.FOUR_THREE_THREE_B.CREATE, FourThreeThree.create),
        takeLatest(SAGA_ACTIONS.FOUR_THREE_THREE_B.UPDATE, FourThreeThree.update),
        takeLatest(SAGA_ACTIONS.FOUR_THREE_THREE_B.MONTHLY_EXPENSE, FourThreeThree.getIncome),
        takeLatest(SAGA_ACTIONS.PERSONAL_BALANCE_SHEET.CREATE, FourThreeThree.createBS),
        takeLatest(SAGA_ACTIONS.PERSONAL_BALANCE_SHEET.DETAILS, FourThreeThree.fetchBS),
        takeLatest(SAGA_ACTIONS.PERSONAL_INCOME_STATMENT.CREATE, FourThreeThree.createPI),
        takeLatest(SAGA_ACTIONS.PERSONAL_INCOME_STATMENT.DETAILS, FourThreeThree.fetchPI),

        // takeLatest(SAGA_ACTIONS.SETTINGS.FETCH_DETAILS, Settings.fetchSettings),
        takeLatest(SAGA_ACTIONS.SETTINGS.UPDATE_ACCOUNTING, Settings.updateAccountingSettings),
        takeLatest(SAGA_ACTIONS.SETTINGS.UPDATE_SALES, Settings.updateSalesSettings),
        takeLatest(SAGA_ACTIONS.SETTINGS.FETCH_ACCOUNT_DETAILS, Settings.fetchAccountSettings),
        takeLatest(SAGA_ACTIONS.SETTINGS.UPGRADE_TO_LATEST_GL, Settings.updateTolatestGl),

        takeLatest(SAGA_ACTIONS.BUDGET.FETCH_DETAILS, Budget.fetchBudget),
        takeLatest(SAGA_ACTIONS.BUDGET.ADD, Budget.addBudget),
        takeLatest(SAGA_ACTIONS.BUDGET.UPDATE, Budget.updateBudget),
        takeLatest(SAGA_ACTIONS.BUDGET.PUBLISH, Budget.publishBudget),
        takeLatest(SAGA_ACTIONS.BUDGET.DOWNLOAD_REPORT, Budget.downloadBudgetReport),
        takeLatest(SAGA_ACTIONS.BUDGET.DOWNLOAD_REPORT_EXCEL, Budget.downloadBudgetReportExcel),

        takeLatest(SAGA_ACTIONS.CREDIT_CARD.FETCH_LIST, CreditCard.listCreditCardCsvRecords),
        takeLatest(SAGA_ACTIONS.CREDIT_CARD.FETCH_DETAILS, CreditCard.fetchCreditCardCsvRecord),
        takeLatest(SAGA_ACTIONS.CREDIT_CARD.UPLOAD_CSV, CreditCard.uploadCreditCardCsv),
        takeLatest(SAGA_ACTIONS.CREDIT_CARD.CC_UPLOAD, CreditCard.creditCardUpload),
        takeLatest(SAGA_ACTIONS.CREDIT_CARD.CC_DELETE, CreditCard.deleteCreditCardCsv),
        takeLatest(SAGA_ACTIONS.CREDIT_CARD.YEAR_LOCK_CHECK, CreditCard.checkYearLock),
        takeLatest(SAGA_ACTIONS.CREDIT_CARD.LOCKED_YEARS_LIST, CreditCard.getLockedYearsList),

        takeLatest(SAGA_ACTIONS.QUICK_BOOK.AUTH, QuickBook.auth),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.CALLBACK, QuickBook.callback),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.IMPORT_DATA, QuickBook.importDate),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.FETCH_ACCOUNT_CHARTS, QuickBook.fetchAccountChart),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.POST_ACCOUNT_CHARTS, QuickBook.postAccountChart),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.CLASSIFICATION_MAP, QuickBook.classificationMap),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.PARENT_MATCH, QuickBook.matchQboParent),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_OPENNING_BALANCE, QuickBook.qbFetchOpenningAcc),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_POST_OPENNING_BALANCE, QuickBook.qbPostOpenningAcc),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_BS_PL, QuickBook.qbFetchBSPL),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_POST_BS_PL, QuickBook.qbPostBSPL),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_BS, QuickBook.qbFetchBS),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_PL, QuickBook.qbFetchPL),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_VENDORS, QuickBook.qbFetchVendors),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_CUSTOMERS, QuickBook.qbFetchCustomers),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_JOB_STATUS, QuickBook.qbFetchJobStatus),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_ACKNOWLEDGE_JOB_WARNINGS, QuickBook.qbAcknowledgeJobWarnings),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_IMPORT_JOB_STATUS, QuickBook.qbFetchImportJobStatus),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_LEDGER_AUDIT, QuickBook.qbFetchLedgerAudit),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_LEDGER_RETRY, QuickBook.qbRetryLedgerPeriod),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_LEDGER_RETRY_ALL, QuickBook.qbRetryLedgerPeriods),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QB_LEDGER_MAPPINGS, QuickBook.qbSaveLedgerMappings),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QBO_BACKUP_LATEST, QuickBook.qbFetchBackupLatest),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QBO_BACKUP_STATUS, QuickBook.qbFetchBackupStatus),
        takeLatest(SAGA_ACTIONS.QUICK_BOOK.QBO_BACKUP_RETRY, QuickBook.qbRetryBackup),
        takeLatest(SAGA_ACTIONS.CHART_ACCOUNT.DELETE, chartAccount.deleteChart),

        takeLatest(SAGA_ACTIONS.TAX_RESOLUTIONS.DETAILS, FourThreeThree.getTaxResolutionData),
        takeLatest(SAGA_ACTIONS.TAX_RESOLUTIONS.CREATE, FourThreeThree.saveTaxResolutionData),
        takeLatest(SAGA_ACTIONS.TAX_RESOLUTIONS.PUBLISH, FourThreeThree.publishTaxResolutionData),
        takeLatest(SAGA_ACTIONS.TAX_RESOLUTIONS.PNL, FourThreeThree.getTaxResolutionPnl),
        takeLatest(SAGA_ACTIONS.TAX_RESOLUTIONS.DRAFT_LIST, FourThreeThree.getTaxResolutionDraft),

        takeEvery(SAGA_ACTIONS.TAX_1099.VENDOR_LIST, Tax1099.getVendorList),
        takeLatest(SAGA_ACTIONS.TAX_1099.UNMAPPED_PAYEES, Tax1099.getUnmappedPayees),
        takeLatest(SAGA_ACTIONS.TAX_1099.RESOLVE_PAYEE, Tax1099.resolvePayee),
        takeLatest(SAGA_ACTIONS.TAX_1099.VENDOR_DETAILS, Tax1099.getVendorDetails),
        takeLatest(SAGA_ACTIONS.TAX_1099.VENDOR_CREATE, Tax1099.createVendor),
        takeLatest(SAGA_ACTIONS.TAX_1099.VENDOR_UPDATE, Tax1099.updateVendor),
        takeLatest(SAGA_ACTIONS.TAX_1099.VENDOR_DELETE, Tax1099.deleteVendor),
        takeLatest(SAGA_ACTIONS.TAX_1099.PAYER_SETTINGS_GET, Tax1099.getPayerSettings),
        takeLatest(SAGA_ACTIONS.TAX_1099.PAYER_SETTINGS_SAVE, Tax1099.savePayerSettings),
        takeLatest(SAGA_ACTIONS.TAX_1099.PAYER_W9_UPLOAD, Tax1099.uploadPayerW9),
        takeLatest(SAGA_ACTIONS.TAX_1099.PAYER_W9_PDF, Tax1099.downloadPayerW9Pdf),
        takeEvery(SAGA_ACTIONS.TAX_1099.PAYMENT_LIST, Tax1099.getPaymentList),
        takeLatest(SAGA_ACTIONS.TAX_1099.PAYMENT_DETAILS, Tax1099.getPaymentDetails),
        takeLatest(SAGA_ACTIONS.TAX_1099.PAYMENT_CREATE, Tax1099.createPayment),
        takeLatest(SAGA_ACTIONS.TAX_1099.PAYMENT_UPDATE, Tax1099.updatePayment),
        takeLatest(SAGA_ACTIONS.TAX_1099.PAYMENT_DELETE, Tax1099.deletePayment),
        takeLatest(SAGA_ACTIONS.TAX_1099.PAYMENT_SUMMARY, Tax1099.getPaymentSummary),
        takeEvery(SAGA_ACTIONS.TAX_1099.FORM_LIST, Tax1099.getFormList),
        takeLatest(SAGA_ACTIONS.TAX_1099.FORM_DETAILS, Tax1099.getFormDetails),
        takeLatest(SAGA_ACTIONS.TAX_1099.FORM_GENERATE_BATCH, Tax1099.generateFormsBatch),
        takeLatest(SAGA_ACTIONS.TAX_1099.FORM_GENERATE_VENDOR, Tax1099.generateFormForVendor),
        takeLatest(SAGA_ACTIONS.TAX_1099.W9_EXTRACT, Tax1099.extractW9),
        takeLatest(SAGA_ACTIONS.TAX_1099.W9_CONFIRM, Tax1099.confirmW9),
        takeLatest(SAGA_ACTIONS.TAX_1099.W9_CURRENT, Tax1099.getCurrentW9),
        takeLatest(SAGA_ACTIONS.TAX_1099.W9_PDF, Tax1099.downloadW9Pdf),
        takeLatest(SAGA_ACTIONS.TAX_1099.FORM_PDF, Tax1099.downloadFormPdf),
        takeLatest(SAGA_ACTIONS.TAX_1099.STATEMENT_EVIDENCE, Tax1099.downloadStatementEvidence),
        takeLatest(SAGA_ACTIONS.TAX_1099.FORM_APPROVE, Tax1099.approveForm),
        takeLatest(SAGA_ACTIONS.TAX_1099.FORM_UNAPPROVE, Tax1099.unapproveForm),
        takeLatest(SAGA_ACTIONS.TAX_1099.YEAR_END_STATUS, Tax1099.getYearEndPackageStatus),
        takeLatest(SAGA_ACTIONS.TAX_1099.YEAR_END_APPROVE, Tax1099.approveYearEndPackage),
        takeLatest(SAGA_ACTIONS.TAX_1099.FORM_VOID, Tax1099.voidForm),
        takeLatest(SAGA_ACTIONS.TAX_1099.FORM_FURNISH_EMAIL, Tax1099.furnishFormByEmail),
        takeLatest(SAGA_ACTIONS.TAX_1099.FORM_CORRECT, Tax1099.correctForm),
        takeLatest(SAGA_ACTIONS.TAX_1099.VENDOR_SYNC_QBO, Tax1099.syncQboVendors),
        takeLatest(SAGA_ACTIONS.TAX_1099.PAYMENT_SYNC_EXPENSES, Tax1099.syncExpenses),
        takeLatest(SAGA_ACTIONS.TAX_1099.VENDOR_PAYMENTS, Tax1099.getVendorPayments),
        takeLatest(SAGA_ACTIONS.TAX_1099.VENDOR_NEXT_CODE, Tax1099.getNextVendorCode),

    ])
}
